"use client";

import React from "react";

import { notifyMessage } from "@/utils/toasts/notifyMessage";
import { SupTalk } from "@repo/core-ui";
import dictionaryConfig from "@/../config/dictionary.config";

export default function UiWidgetMavaButton() {
  function openMava() {
    // @ts-ignore
    if (window && window.MavaWebChatToggle !== undefined) {
      // @ts-ignore
      window.MavaWebChatToggle();
    } else {
      notifyMessage("Mava not available", "Please contact us directly using Discord", "error");
    }
  }

  return (
    <button
      type="button"
      className="txt-16_24 flex h-12 items-center p-3 text-neutral-900 duration-100 hover:ease-in md:hover:bg-primary-75 md:hover:text-neutral-700 lg:flex"
      onClickCapture={openMava}
    >
      <span className="h-10 w-10 p-2">
        <SupTalk />
      </span>
      <span className="pr-4">{dictionaryConfig.intercomButtonCaption}</span>
    </button>
  );
}
